// extracted by mini-css-extract-plugin
module.exports = {"fontBold":"CompanySelectedComponent_fontBold__3NWhg","title":"CompanySelectedComponent_title__I-66S","companyname":"CompanySelectedComponent_companyname__voU8g"};